import { gql } from '@apollo/client';

export const CREATE_CONTROL_VISIT = gql`
mutation CreateCvMutation($date: String!, $storeCode: String!, $status: StatusInput!, $requestedTime: RequestedTimeInput!, $appointmentType: AppointmentTypeInput) {
    createAppointmentByStoreCode(
      appointment: {
        type: "Appointment",
        date: $date,
        storeCode: $storeCode,
        status: $status,
        requestedTime: $requestedTime,
        appointmentType: $appointmentType,
      }
    ) {
      id
    }
  }
`;
